"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPdfHighlighter = require("react-pdf-highlighter");
var _styles = _interopRequireDefault(require("./styles"));
require("./styles.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Reader(props) {
  var {
    url,
    setPdf,
    highlights,
    onSelection,
    onClickHighlight,
    scale,
    containerStyle,
    focus,
    setFocus
  } = props;
  var pdfRef = (0, _react.useRef)();
  var scrollToRef = (0, _react.useRef)();
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    if (!pdfRef.current) return;
    pdfRef.current.viewer.currentScaleValue = scale;
  }, [scale]);
  (0, _react.useEffect)(() => {
    if (!focus || !Object.keys(focus).length) return;
    scrollToRef.current(focus);
    setFocus();
  }, [focus, setFocus]);
  function onLoadPdf(pdf) {
    pdfRef.current = pdf;
    setPdf(pdf);
  }
  function onSelectionFinished(position, content) {
    var range = window.getSelection().getRangeAt(0);
    var startEl = range.startContainer.parentElement;
    var endEl = range.endContainer.parentElement;
    onSelection({
      position,
      content,
      startEl,
      endEl
    });
  }
  function onHighlightTransform(highlight, index, _setTip, _hideTip, _viewportToScaled, _screenshot, isScrolledTo) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: highlight.color,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_reactPdfHighlighter.Highlight, {
      onClick: () => onClickHighlight(highlight),
      isScrolledTo: isScrolledTo,
      position: highlight.position
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper,
    style: containerStyle
  }, /*#__PURE__*/_react.default.createElement(_reactPdfHighlighter.PdfLoader, {
    url: url
  }, pdfDocument => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactPdfHighlighter.PdfHighlighter, {
    pdfDocument: pdfDocument,
    ref: onLoadPdf,
    scrollRef: scrollTo => scrollToRef.current = scrollTo,
    highlights: highlights,
    onSelectionFinished: onSelectionFinished,
    highlightTransform: onHighlightTransform,
    pdfScaleValue: scale,
    onScrollChange: () => setFocus()
  }))));
}
Reader.propTypes = {
  url: _propTypes.default.string.isRequired,
  setPdf: _propTypes.default.func.isRequired,
  highlights: _propTypes.default.array.isRequired,
  onClickHighlight: _propTypes.default.func.isRequired,
  onSelection: _propTypes.default.func.isRequired,
  scale: _propTypes.default.number.isRequired,
  focus: _propTypes.default.object.isRequired,
  setFocus: _propTypes.default.func.isRequired
};
var _default = exports.default = Reader;